/**
 * OneTrust UI helpers.
 *
 * OneTrust consent gating itself lives in `@ubnt/store.core/lib/tracking`
 * (AutoBlock renders blocked scripts, `useOneTrustConsent` exposes state).
 * The one piece the shared module does not handle is re-translating the
 * banner + preference center when the user switches UI language — that is
 * what this helper covers.
 *
 * @see https://developer.onetrust.com/onetrust/docs/single-page-applications
 */

import { Language } from "@ubnt/store.core/lib/types";

const getLanguageCode = (language?: string): string => {
  const lowercasedLang = language?.toLowerCase() ?? Language.En;
  if (lowercasedLang.includes("-")) {
    // @NOTE Extract primary language code (Taiwanese not supported yet)
    return lowercasedLang.split("-")[0];
  }
  return lowercasedLang;
};

/**
 * Switch the OneTrust banner / preference center to the new language. Safe to
 * call when OneTrust hasn't mounted yet — it no-ops.
 */
export const syncOneTrustLanguage = (language?: string): void => {
  window.OneTrust?.changeLanguage?.(getLanguageCode(language));
};
